











































































import { Component, Mixins } from 'vue-property-decorator';
import { ListingFilter, TestimonialFilter, TestimonialOrderBy } from 'client-website-ts-library/filters';
import { View } from 'client-website-ts-library/plugins';
import { Context, WebsiteLevel } from 'client-website-ts-library/types';

import { ContextItemType } from 'client-website-ts-library/types/Context';
import { Config } from 'client-website-ts-library/services';
import Form from '@/components/Forms/Form.vue';
import Listings from '../components/Listings.vue';
import ListingSearch from '../components/ListingSearch.vue';
import ElfsightInstagram from '../components/ElfsightInstagram.vue';
import TestimonialCycler from '../components/Testimonials/TestimonialCycler.vue';
import ContactPopout from '../components/ContactPopout.vue';

@Component({
  components: {
    Listings,
    ListingSearch,
    ElfsightInstagram,
    TestimonialCycler,
    ContactPopout,
    Form,
  },
})
export default class PropertiesForRent extends Mixins(View) {
  private listingFilter: ListingFilter | null = null;

  testimonialFilter: TestimonialFilter | null = null;

  private formData: Context | null = null;

  handleFilter(filter: ListingFilter) {
    this.listingFilter = filter;
  }

  mounted() {
    this.testimonialFilter = new TestimonialFilter({
      SearchLevel: WebsiteLevel.Office,
      SearchGuid: '29d9080e-165e-4372-afc4-374f5b90fdde',
      OrderByStatements: [TestimonialOrderBy.CreateDateDesc],
    });

    this.formData = {
      Items: [
        {
          Type: ContextItemType.EnquiryTargetProfile,
          Id: '109843d2-21f8-49de-891c-3eab8871123d',
        },
      ],
      ClientWebsiteId: Config.Website.Id,
      WebsiteId: Config.Website.Settings!.WebsiteId,
      WebsiteLevel: Config.Website.Settings!.WebsiteLevel,
    };
  }
}
